export default __webpack_public_path__ + "img/f95451dc5befb574ffea6d3e123be8e5.mp4";